import styled from '../../helpers/styled';

export const ManabiScreen = styled.div`
`;

export const ManabiBanner = styled.img`
    width: 100%;
`;